
interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0f172a]/80 backdrop-blur-xl shadow-lg shadow-[#fcd34d]/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/a998d8e2bc83563df5e77ccf9320362e/da1a339545deebac7eedb896376bd118.jpeg"
              alt="Syed Abdul Raheem Designs Logo"
              className="w-12 h-12 rounded-full object-cover ring-2 ring-[#fcd34d]/50 shadow-lg shadow-[#fcd34d]/30"
            />
            <span className="text-xl font-bold text-white font-['Montserrat']">
              SAR Designs
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-[#fcd34d] transition-colors duration-300 font-['Roboto'] whitespace-nowrap cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-[#fcd34d] transition-colors duration-300 font-['Roboto'] whitespace-nowrap cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-white/80 hover:text-[#fcd34d] transition-colors duration-300 font-['Roboto'] whitespace-nowrap cursor-pointer"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-white/80 hover:text-[#fcd34d] transition-colors duration-300 font-['Roboto'] whitespace-nowrap cursor-pointer"
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2 bg-gradient-to-r from-[#fcd34d] to-[#facc15] text-[#0f172a] rounded-full font-semibold font-['Poppins'] hover:shadow-lg hover:shadow-[#fcd34d]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Contact Me
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
